import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import { subscribeToTokenChange } from '@/authz/token-events';
import { getUserData } from '@/constants/global';
import { helpKeys } from '@/hooks/queries/help-centre/help-centre-keys';

/**
 * Drop every cached Help Centre answer when the signed-in identity changes (logout, another user
 * signing in, another tab logging out).
 *
 * Reader keys are already permission-scoped, but the editor's article cache is not and holds
 * `staleTime: Infinity` drafts — and the query cache outlives a logout in the same tab. A token
 * ROTATION for the same user keeps the cache: it changes nothing anyone can see.
 */
export const useHelpSessionReset = () => {
	const queryClient = useQueryClient();

	useEffect(() => {
		let identity = getUserData().user?.UserId ?? null;
		return subscribeToTokenChange(() => {
			const next = getUserData().user?.UserId ?? null;
			if (next === identity) return;
			identity = next;
			queryClient.removeQueries({ queryKey: helpKeys.all });
		});
	}, [queryClient]);
};
